module.exports = __webpack_public_path__ + "static/media/img_3.764520a4.png";